import React, { FC } from "react";
import { Table } from "../../organisms/Table";
import { HeaderText, TableWrapper, Wrapper } from "./elements";

type Props = {
  tableData: any[];
  columns: any[];
  setRowRecord?: any;
  isLoading?: boolean;
  onScroll?: any;
  onChange?: (pagination: any, filters: any) => void;
  total: number;
  currentPage?: number | undefined;
};

const ScouterTest: FC<Props> = ({
  tableData,
  columns,
  setRowRecord,
  isLoading,
  onScroll,
  onChange,
  total,
  currentPage,
}) => {
  return (
    <Wrapper onScroll={onScroll}>
      <HeaderText>Psychological Exam</HeaderText>
      <TableWrapper>
        <Table
          isLoading={isLoading}
          tableData={tableData}
          columns={columns}
          rowRecord={setRowRecord}
          onChange={onChange}
          totalItems={total}
          current={currentPage}
        />
      </TableWrapper>
    </Wrapper>
  );
};

export default ScouterTest;
